import styled from 'styled-components';
import React from 'react';
export const AppMetierTable = styled.table `
  table-layout: fixed;
  background-color: white;
  padding: 5px;
  border-collapse: collapse;
  margin-bottom: 20px;
  color: var(--main-black-2);

  * {
    white-space: nowrap;
  }

  td {
    padding: 5px 10px;

    &.suggest {
      * span {
        width: 100%;
      }
      * .suggest {
        width: 100%;
      }
    }

    &.action {
      padding: 0;
      text-align: center;
    }

    input {
      line-height: 30px;
      height: 30px;
    }
  }

  td.intermediaire {
    background-color: var(--main-blue-3);
  }

  th.intermediaire {
    background-color: var(--main-blue-3);
  }

  th {
    font-size: 16px;
    line-height: 30px;
    color: var(--main-black-1);
    font-weight: var(--bold);
    position: relative;

    &.ttc {
      background-color: rgb(155, 205, 255, 0.2);
    }

    &.title {
      padding: 0;
      text-align: start;
      font-weight: var(--bold);
      font-size: 20px;
      line-height: 22px;
    }

    &.select-cell {
      display: flex;
      justify-content: center;
    }

    &.transparent {
      background: var(--main-blue-2);
    }

    &.action {
      min-width: 30px;
    }
  }

  .suggest-input {
    input {
      max-width: unset;
    }
  }

  button {
    width: 100%;
  }

  thead {
    tr:last-child {
      border-bottom: 3px var(--main-blue-2) solid;
    }
  }

  tr {
    &.hoverable {
      :hover {
        background: linear-gradient(var(--main-green-2), var(--main-green-2)) no-repeat 15px 0;
      }
    }

    &.result {
      background: linear-gradient(var(--main-blue-1), var(--main-blue-1)) no-repeat 15px 0;
      color: white;
      th {
        color: white;
      }
    }

    th:first-child {
      width: 375px;
    }

    td:first-child {
      padding-left: 20px;
    }

    th:not(:first-child):not(:last-child) {
      min-width: 7em;
      max-width: 310px;
      width: 310px;
    }

    td:nth-child(2) {
      box-shadow: inset 7px 0 9px -9px rgba(0, 0, 0, 0.4);
    }
  }

  tbody.stripped tr:nth-child(even):not(.empty) {
    background: linear-gradient(var(--main-grey-3), var(--main-grey-3)) no-repeat 15px 0;
  }

  .subtotal {
    background: linear-gradient(var(--main-grey-3), var(--main-grey-3)) no-repeat 15px 0;
    font-weight: var(--bold);
  }

  .total {
    background: linear-gradient(var(--main-blue-1), var(--main-blue-1)) no-repeat 15px 0;
    font-weight: var(--bold);
    color: white;
  }

  tfoot.total tr.dataline {
    background: linear-gradient(var(--main-blue-1), var(--main-blue-1)) no-repeat 15px 0;
    font-weight: var(--bold);
    color: white;
    td:last-child {
      background: linear-gradient(white, white) no-repeat 40px 0;
    }
  }
`;
export const BlankTableLine = ({ cellNumber }) => {
    return (React.createElement("tr", { className: 'empty' }, [...Array(cellNumber)].map((_, i) => (React.createElement("td", { key: i })))));
};
//# sourceMappingURL=AppMetierTable.js.map